import {Component, Inject, OnInit} from '@angular/core';
import {AuthService} from "../../_services/auth.service";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {SafeUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-qr-generate-modal',
  templateUrl: './qr-generate-modal.component.html',
  styleUrl: './qr-generate-modal.component.css'
})
export class QrGenerateModalComponent implements OnInit{
  constructor(
    private authService: AuthService,
    public dialogRef: DialogRef<QrGenerateModalComponent>,
    @Inject(DIALOG_DATA) public data: any
  ) { }
  public myAngularxQrCode: string = `mobileSign:https://api-sc.egov.kz/v1/contracts/qr_generator/api1/${this.data.contractId}`;
  public qrCodeDownloadLink: SafeUrl = "";
  ngOnInit(): void {
  }
  closeDialog(): void {
    this.data.onClose();
    this.dialogRef.close();
  }

}
